import React from "react"
import ScrollToTop from "react-scroll-up"
import { Button } from "reactstrap"
import { Heart, ArrowUp } from "react-feather"
import classnames from "classnames"

const Footer = props => {
  let footerTypeArr = ["sticky", "static", "hidden"]
  return (
    <footer
      className={classnames("footer footer-light", {
        "footer-static": props.footerType === "static" || !footerTypeArr.includes(props.footerType),
        "d-none": props.footerType === "hidden"
      })}
      style={{
        paddingTop: 0,
        paddingBottom: 0,
      }}
    >
      <p className="mb-0 clearfix">
        <span className="float-md-left d-block d-md-inline-block mt-25">
          COPYRIGHT © {new Date().getFullYear()}
          <a
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            className="text-dark text-bold-600"
          >
            Management of Change,
          </a>
          All rights reserved
        </span>
      </p>
      {props.hideScrollToTop === false ? (
        <ScrollToTop showUnder={160}>
          <Button color="success" className="btn-icon scroll-top">
           <span style={{color: "#333333"}}> <ArrowUp size={15} /></span>
          </Button>
        </ScrollToTop>
      ) : null}
    </footer>
  )
}

export default Footer
